export default "__VITE_ASSET__Cpho$1G5__"